import { RouterLink } from 'vue-router'

const defaultOptions = {
  external: false,
  class: '',
}

export default (text: string | VNode, to: string, options = defaultOptions) => () => h(RouterLink, { to, ...options }, () => text)
